const API_URL = 'https://drbskhealthcare.com/';

// const API_URL = 'http://localhost:4000/'

// const API_URL = "https://j449fxt7-4000.inc1.devtunnels.ms/"


export default API_URL;